import type { WeeklyCalculatorFormValues } from "../types/form"

/**
 * Returns the default values for a new weekly calculator form.
 * Distributions reflect typical call center patterns:
 * - Weekdays are busier (Monday-Friday)
 * - Wednesday tends to be peak
 * - Weekends have lower volume
 */
export function getDefaultWeeklyFormValues(): WeeklyCalculatorFormValues {
  return {
    // Core fields (period removed - calculator type determined by route)
    incomingContacts: "400",
    averageHandleTimeSeconds: "257",
    requiredServiceLevel: "80",
    targetAnswerTimeSeconds: "20",
    shrinkage: "30",
    maxOccupancy: "85",
    averagePatienceSeconds: "60",
    workingHoursPerWeek: "37.5",
    reportingInterval: "30min",

    // Weekly-specific fields
    hoursOpenPerDay: "9",
    weekStart: "monday",
    distributionMonday: "23.8",
    distributionTuesday: "21.6",
    distributionWednesday: "19.5",
    distributionThursday: "18.6",
    distributionFriday: "16.5",
    distributionSaturday: "0",
    distributionSunday: "0",
  }
}

/**
 * Calculates the total of all day distribution percentages
 */
export function calculateDistributionTotal(values: Record<string, string>): number {
  const dayKeys = [
    "distributionMonday",
    "distributionTuesday",
    "distributionWednesday",
    "distributionThursday",
    "distributionFriday",
    "distributionSaturday",
    "distributionSunday",
  ]

  return dayKeys.reduce((sum, key) => {
    const value = values[key]
    return sum + (Number(value) || 0)
  }, 0)
}

/**
 * Checks if the distribution total is valid (equals 100%, with floating point tolerance)
 */
export function isDistributionValid(values: Record<string, string>): boolean {
  const total = calculateDistributionTotal(values)
  return Math.abs(total - 100) < 0.01
}
